//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocRow from './sub/WorkHistoryRow.vue';
export default {
	name: "WorkHistoryTable",
	props: {
		form: {
			type: Object,
			required: true
		},
		doc: {
			type: Object,
			required: true
		},
		is_new: {
			type: Boolean,
			required: true
		},
		allow_edit: {
			type: Boolean,
			required: true
		},
		set_value: {
			type: Function,
			required: true
		},
	},
	data() {
		const { doc } = this;

		if (!doc.external_work_history) {
			doc.external_work_history = new Array();
		}

		const data = {
			rows: this.doc.external_work_history,
		};

		return data;
	},
	components: {
		DocRow,
	},
	methods: {
		add_row() {
			const { rows } = this;
			const new_row = {
				company_name: "",
				designation: "",
				salary: "",
				address: "",
				contact: "",
				total_experience: "",
			};
			rows.push(new_row);
		},
		delete_row(index) {
			const { rows } = this;
			const start = index - 1;
			const delete_count = 1;
			rows.splice(start, delete_count);4
		},
	}
}
